var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnSampleSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #FFFFFF;\n        stroke-width: 2px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 64,
    height: 64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_sample_setup"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.93,
    y: 10,
    width: 16.3,
    height: 5.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.18,52.77c0,.68-1.57,1.23-2.25,1.23s-2.25-.55-2.25-1.23l-3.6-6.79V15.09h11.7v16.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.09,
    y1: 20.6,
    x2: 24.58,
    y2: 20.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.09,
    y1: 26.1,
    x2: 24.58,
    y2: 26.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.09,
    y1: 31.6,
    x2: 24.58,
    y2: 31.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.09,
    y1: 37.1,
    x2: 24.58,
    y2: 37.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.09,
    y1: 42.6,
    x2: 24.58,
    y2: 42.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "44.33 48.26 45.55 49.66 42.74 52.48 41.34 51.26 39.19 52.14 39.06 54 35.09 54 34.96 52.14 32.81 51.26 31.41 52.48 28.6 49.66 29.82 48.26 28.93 46.12 27.08 45.99 27.08 42.01 28.93 41.88 29.82 39.74 28.6 38.34 31.41 35.52 32.81 36.75 34.96 35.86 35.09 34 39.06 34 39.19 35.86 41.34 36.75 42.74 35.52 45.55 38.34 44.33 39.74 45.22 41.88 47.08 42.01 47.08 45.99 45.22 46.12 44.33 48.26"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 37.08,
    cy: 44,
    r: 4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSampleSetup);
export default __webpack_public_path__ + "static/media/icn_sample_setup.aecb9c5bb1a03dd2b8ee7e728934bae2.svg";
export { ForwardRef as ReactComponent };